import { EmailTemplate } from '../types/emailTemplates';
import { useTranslation } from 'react-i18next';
import { getCategoryBadgeStyle } from './config';
import { FC } from 'react';

type EmailTemplateCardProps = {
  template: EmailTemplate;
  onEdit: (templateId: string) => void;
  onRequestDelete: (template: EmailTemplate) => void;
};

export const EmailTemplateCard: FC<EmailTemplateCardProps> = ({ template }) => {
  const { t } = useTranslation('campaign');
  const showCreatedLabel = template.createdAtLabel !== template.updatedAtLabel;

  return (
    <article className='rounded-2xl border border-secondary-border bg-white p-4 shadow-sm'>
      <div className='flex items-center justify-between gap-3'>
        <span className={`rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.16em] ${getCategoryBadgeStyle(template.category)}`}>
          {template.category}
        </span>
      </div>

      <div className='mt-3 space-y-1'>
        <h4 className='text-sm font-semibold text-slate-900'>{template.name}</h4>
      </div>

      <div className='mt-3 space-y-1'>
        <p className='text-[10px] font-semibold uppercase tracking-[0.16em] text-quaternary-500'>{t('emailWorkspace.templates.subjectLabel')}</p>
        <div className='rounded-lg bg-green-50 px-3 py-2 text-xs leading-5 text-secondary-700'>
          <p className='line-clamp-2'>{template.subject}</p>
        </div>
      </div>

      <div className='mt-4 flex items-center justify-between gap-2 text-xs text-secondary-500'>
        <div className='min-w-0 space-y-0.5'>
          <span>{template.updatedAtLabel}</span>
          {showCreatedLabel ? <p className='text-[10px] text-quaternary-500'>{template.createdAtLabel}</p> : null}
        </div>
        {/* <ActionButton onEdit={() => onEdit(template.id)} onDelete={() => onRequestDelete(template)} /> */}
      </div>
    </article>
  );
};
